import type { IntlShape, MessageDescriptor } from 'react-intl';

import * as PM from '@/messages/payment';

const WITHDRAWAL_DISABLED_REASON_MESSAGES: Record<string, MessageDescriptor> = {
  CUSTOMIZED_GOOD: PM.paymentMessages.withdrawalDisabledReasonCustomizedGood,
  GIFT_ITEM: PM.paymentMessages.withdrawalDisabledReasonGiftItem,
  HISTORICAL_CERTIFICATE:
    PM.paymentMessages.withdrawalDisabledReasonHistoricalCertificate,
  INVALID_LINE_STATUS:
    PM.paymentMessages.withdrawalDisabledReasonInvalidLineStatus,
  INVALID_ORDER_STATUS:
    PM.paymentMessages.withdrawalDisabledReasonInvalidOrderStatus,
  OUT_OF_EU_SCOPE: PM.paymentMessages.withdrawalDisabledReasonOutOfEuScope,
  WINDOW_EXPIRED: PM.paymentMessages.withdrawalDisabledReasonWindowExpired,
};

export function withdrawalDisabledReasonLabel(
  code: string,
  formatMessage: IntlShape['formatMessage'],
): string {
  const descriptor = WITHDRAWAL_DISABLED_REASON_MESSAGES[code];
  return descriptor ? formatMessage(descriptor) : code;
}
